var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"swap-page-container"},[_c('div',{staticClass:"mt-5",class:{ showChart: _vm.showChart },attrs:{"id":"swap-page"}},[_c('SwapWidget',{staticClass:"swap-widget-container",on:{"onChartClick":_vm.onChart}}),_c('client-only',[(_vm.showChart)?_c('div',{staticClass:"chart-container"},[_c('SwapChart')],1):_vm._e()])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }